import React from 'react';
import { XIcon, CheckCircleIcon } from 'lucide-react';
// iOS-style share icon component
function IOSShareIcon({
  className = 'w-6 h-6'
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-620">
      <path d="M8.59 13.51l6.83 3.98" data-id="element-621" />
      <path d="M15.41 6.51l-6.82 3.98" data-id="element-622" />
      <circle cx="18" cy="5" r="3" data-id="element-623" />
      <circle cx="6" cy="12" r="3" data-id="element-624" />
      <circle cx="18" cy="19" r="3" data-id="element-625" />
    </svg>;
}
export function ShareInstructions({
  onClose,
  onContinue
}) {
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end justify-center animate-fadeIn" data-id="element-626">
      <div className="bg-white rounded-t-3xl w-full max-w-lg animate-slideUp max-h-[85vh] overflow-y-auto" data-id="element-627">
        <div className="sticky top-0 bg-white p-6 border-b border-gray-100 rounded-t-3xl" data-id="element-628">
          <div className="flex items-center justify-between" data-id="element-629">
            <h2 className="text-xl font-semibold text-gray-900" data-id="element-630">
              How to Share Events
            </h2>
            <button onClick={onClose} className="p-2 -mr-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Close" data-id="element-631">
              <XIcon className="w-5 h-5 text-gray-400" data-id="element-632" />
            </button>
          </div>
        </div>

        <div className="p-6 space-y-6" data-id="element-633">
          {/* Hero Icon */}
          <div className="flex justify-center" data-id="element-634">
            <div className="w-20 h-20 bg-blue-100 rounded-2xl flex items-center justify-center" data-id="element-635">
              <IOSShareIcon className="w-10 h-10 text-blue-600" data-id="element-636" />
            </div>
          </div>

          {/* Instructions */}
          <div className="space-y-5" data-id="element-637">
            <div className="flex items-start" data-id="element-638">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-semibold text-sm" data-id="element-639">
                1
              </div>
              <div className="ml-4 flex-1" data-id="element-640">
                <h3 className="font-semibold text-gray-900 mb-1" data-id="element-641">
                  Find an event
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-642">
                  Open Instagram, Eventbrite, or any other app with an event you
                  want to save
                </p>
              </div>
            </div>

            <div className="flex items-start" data-id="element-643">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-semibold text-sm" data-id="element-644">
                2
              </div>
              <div className="ml-4 flex-1" data-id="element-645">
                <h3 className="font-semibold text-gray-900 mb-1" data-id="element-646">
                  Tap the share button
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-647">
                  Look for the share icon (
                  <span className="inline-flex items-center mx-1" data-id="element-648">
                    <IOSShareIcon className="w-3 h-3" data-id="element-649" />
                  </span>
                  ) and tap it to open the share menu
                </p>
              </div>
            </div>

            <div className="flex items-start" data-id="element-650">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-semibold text-sm" data-id="element-651">
                3
              </div>
              <div className="ml-4 flex-1" data-id="element-652">
                <h3 className="font-semibold text-gray-900 mb-1" data-id="element-653">
                  Select the WTM app
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-654">
                  Scroll through the share options and tap the WTM app to save
                  the event
                </p>
              </div>
            </div>

            <div className="flex items-start" data-id="element-655">
              <div className="flex-shrink-0 w-8 h-8 bg-green-600 rounded-full flex items-center justify-center" data-id="element-656">
                <CheckCircleIcon className="w-5 h-5 text-white" data-id="element-657" />
              </div>
              <div className="ml-4 flex-1" data-id="element-658">
                <h3 className="font-semibold text-gray-900 mb-1" data-id="element-659">
                  Review and save
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-660">
                  We'll extract the event details automatically. Just review and
                  save!
                </p>
              </div>
            </div>
          </div>

          {/* Tip Box */}
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4" data-id="element-661">
            <div className="flex items-start" data-id="element-662">
              <div className="flex-shrink-0 text-amber-600 mt-0.5" data-id="element-663">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" data-id="element-664">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" data-id="element-665" />
                </svg>
              </div>
              <div className="ml-3" data-id="element-666">
                <h4 className="text-sm font-semibold text-amber-900 mb-1" data-id="element-667">
                  Pro Tip
                </h4>
                <p className="text-sm text-amber-800 leading-relaxed" data-id="element-668">
                  If you don't see the WTM app in the share menu, scroll to the
                  bottom and tap "Edit Actions" to add it
                </p>
              </div>
            </div>
          </div>

          {/* Action Button */}
          <div className="pt-2" data-id="element-669">
            <button onClick={onContinue} className="w-full py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-colors" data-id="element-670">
              Open the share menu
            </button>
          </div>
        </div>

        {/* Safe area padding for iOS */}
        <div className="h-8" data-id="element-671"></div>
      </div>
    </div>;
}